export const USER_TYPE_EMPLOYEE = 737;
export const USER_TYPE_AGENT = 738;
export const USER_TYPE_BROKER = 739;